<template>
    <div>
        <datepicker ref="dateFrom"
                    v-bind="$attrs"
                    :input-class="inputClassFrom"
                    :value="date.from"
                    :name="nameFrom"
                    :placeholder="placeholderFrom"
                    :disabled-dates="{from: !!this.date.highlighted.to ? this.date.highlighted.to : new Date()}"
                    :highlighted="date.highlighted"
                    @selected="onSelectedDateFrom"
        >
        </datepicker>
        <datepicker ref="dateTo"
                    v-bind="$attrs"
                    :input-class="inputClassTo"
                    :value="date.to"
                    :name="nameTo"
                    :placeholder="placeholderTo"
                    :disabled-dates="{from: date.disabled.from, to: this.date.from}"
                    :highlighted="date.highlighted"
                    @selected="onSelectedDateTo"
        >
        </datepicker>
    </div>
</template>
<script>
    import DatePicker from 'vuejs-datepicker'

    export default {
        name: 'range-datepicker',
        components: {
            'datepicker': DatePicker
        },
        props: {
            'name-from': String,
            'name-to': String,
            'value-from': String,
            'value-to': String,
            'input-class-from': String,
            'input-class-to': String,
            'placeholder-from': String,
            'placeholder-to': String
        },
        data() {
            return {
                date: {
                    from: this.valueFrom,
                    to: this.valueTo,
                    highlighted: {
                        to: null,
                        from: null
                    },
                    disabled: {
                        to: null,
                        from: new Date()
                    }
                },

            }
        },
        methods: {
            onSelectedDateFrom(dateFrom) {
                this.date.from = dateFrom;
                this.date.highlighted.from = dateFrom;
                this.checkDates()
            },
            onSelectedDateTo(dateTo) {
                this.date.to = dateTo;
                this.date.highlighted.to = dateTo;
                this.checkDates()


            },
            checkDates() {
                let isSetToFrom = !!this.date.highlighted.to && !!this.date.highlighted.from;
                let compareDate = this.date.to < this.date.from;

                if(isSetToFrom && compareDate){
                    this.date.from = null;
                    this.date.to = null;
                    this.date.highlighted.to = null;
                    this.date.highlighted.from = null;
                }
            }
        },
        mounted() {
            if(!!this.valueFrom) {
                this.date.highlighted.from = new Date(this.valueFrom);
            }
            if(!!this.valueTo) {
                this.date.highlighted.to = new Date(this.valueTo);
            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/range-datepicker.vue